import styled from 'styled-components';

export const EventsDashboardWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

export const EventsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
  padding-right: 10px;
`;

export const Panel = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  grid-auto-rows: 10px;
  gap: 10px;
`;

export const StyledEventsEmpty = styled.div`
  grid-row: span 5;
  grid-column: span 2;
  display: flex;
  align-items: center;
  padding: 10px;

  div {
    display: flex;
    flex-direction: row;
    padding: 10px;
    border-radius: 3px;
    align-items: center;
    background: rgba(186 216 246 / 20%);
  }

  p {
    font-size: 16px;
    color: #666;
    margin-right: 10px;
    margin-bottom: 0;
  }

  button {
    width: fit-content;
  }
`;
